import { z } from 'zod';

import { StatsWindowSchema } from '../../stats/stats-range/stats-range';
import { BreakdownRowSchema, ComparableCountSchema } from '../../stats/stats-shapes/stats-shapes';

/** One bucket of the submitted-vs-decided chart. */
export const VerificationVolumePointSchema = z
  .object({
    bucket: z.string(),
    submitted: z.number().int().nonnegative(),
    approved: z.number().int().nonnegative(),
    rejected: z.number().int().nonnegative(),
  })
  .strict();

export type VerificationVolumePoint = z.infer<typeof VerificationVolumePointSchema>;

/**
 * The Dashboard's Verification section (D12). Under the **same gender
 * restriction** as the review queues (F7) — a reviewer's own figures, not the
 * platform's.
 */
export const VerificationStatsSchema = z
  .object({
    window: StatsWindowSchema,
    submitted: ComparableCountSchema,
    decided: z.number().int().nonnegative(),
    approvalRate: z.number().min(0).max(1),
    medianDecisionHours: z.number().min(0),
    open: z.number().int().nonnegative(),
    perBucket: z.array(VerificationVolumePointSchema),
    rejectionReasons: z.array(BreakdownRowSchema),
    decidedByGender: z
      .object({ male: z.number().int().nonnegative(), female: z.number().int().nonnegative() })
      .strict(),
  })
  .strict();

export type VerificationStats = z.infer<typeof VerificationStatsSchema>;
